
import { reasonValues } from "containers/Survey/models"
import { vitalsType } from "types/payload";

export const vitals = {
  HEIGHT: 'height',
  WEIGHT: 'weight',
  TEMPERATURE: 'temperature',
  TENSION: 'bp',
  SATURATION: 'spo2',
  HEARTRATE: 'heartrate',
  BMI: 'bmi'
};

/** Bilan check-up : taille, poids, tension, saturation (sans température). */
export const vitalsNeededForCheckup: Array<{
  label: vitalsType
  alwaysNeeded?: boolean
}> = [
  { label: vitals.HEIGHT as vitalsType, alwaysNeeded: true },
  { label: vitals.WEIGHT as vitalsType, alwaysNeeded: true },
  { label: vitals.TENSION as vitalsType, alwaysNeeded: true },
  { label: vitals.SATURATION as vitalsType, alwaysNeeded: true },
]

export const checkupReusableVitals: string[] = [vitals.TENSION, vitals.SATURATION]

export const vitalsNeededByReason: any = {
  [reasonValues.COVID]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, {label: vitals.SATURATION, alwaysNeeded: true }
  ],
  [reasonValues.ALLERGIES]: [
    {label: vitals.WEIGHT}
  ],
  [reasonValues.BURN]: [
    {label: vitals.WEIGHT}
  ],
  [reasonValues.CONTRACEPTION]: [
    {label: vitals.WEIGHT}, { label: vitals.TENSION, alwaysNeeded: true }
  ],
  [reasonValues.CYSTITIS]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}
  ],
  [reasonValues.DIARRHEA_OR_VOMITING]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}
  ],
  [reasonValues.JOINT_PAIN]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}
  ],
  [reasonValues.TOOTH_PAIN]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}
  ],
  [reasonValues.BACK_PAIN]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true }
  ],
  [reasonValues.RASH]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}
  ],
  [reasonValues.TIRED]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true }, { label: vitals.HEARTRATE, alwaysNeeded: true }
  ],
  [reasonValues.FEVER]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true}, { label: vitals.SATURATION, alwaysNeeded: true }
  ],
  [reasonValues.SEXUAL_INFECTION]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true }
  ],
  [reasonValues.SORE_THROAT]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true }
  ],
  [reasonValues.HEADACHE]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true}, { label: vitals.SATURATION, alwaysNeeded: true }
  ],
  [reasonValues.STOMACH_ACHE]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}
  ],
  [reasonValues.EYE_PAIN]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}
  ],
  [reasonValues.OTITIS]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}
  ],
  [reasonValues.STING]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true }
  ],
  [reasonValues.PRESCRIPTION_REFILL]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true}, { label: vitals.SATURATION, alwaysNeeded: true }
  ],
  [reasonValues.PERIOD_PAIN]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true }
  ],
  [reasonValues.LAB_RESULTS]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true}, { label: vitals.SATURATION, alwaysNeeded: true }
  ],
  [reasonValues.COLD_AND_FLU]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true}, { label: vitals.SATURATION, alwaysNeeded: true }
  ],
  [reasonValues.SINUS]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true}, { label: vitals.SATURATION, alwaysNeeded: true }
  ],
  [reasonValues.COUGH]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true}, { label: vitals.SATURATION, alwaysNeeded: true }
  ],
  [reasonValues.OTHER_REASON]: [
    {label: vitals.WEIGHT}, {label: vitals.TEMPERATURE, alwaysNeeded: true}, { label: vitals.TENSION, alwaysNeeded: true}, { label: vitals.SATURATION, alwaysNeeded: true }
  ]
};

export const GET_VITALS_BY_TYPE = 'GET_VITALS_BY_TYPE';
export const HYDRATE_VITALS = 'HYDRATE_VITALS';
export const SET_VITALS_STEP = 'SET_VITALS_STEP';
export const RESET_VITALS = 'RESET_VITALS';
export const SET_CHECKUP_VITALS = 'SET_CHECKUP_VITALS';